import { render, staticRenderFns } from "./SaleInvoicesLinesTable.vue?vue&type=template&id=889a9a58&scoped=true&"
import script from "./SaleInvoicesLinesTable.vue?vue&type=script&lang=js&"
export * from "./SaleInvoicesLinesTable.vue?vue&type=script&lang=js&"
import style0 from "./SaleInvoicesLinesTable.vue?vue&type=style&index=0&id=889a9a58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889a9a58",
  null
  
)

export default component.exports